import { batch, observable } from '@legendapp/state';
import { Pattern } from '../constants';
import { autoBetState$ } from './auto-bet.state';
import { towersState$ } from './towers.state';
import { winDisplayState$ } from './win-display.state';

type GameState = {
  pattern: Pattern;
  setPattern: (pattern: Pattern) => void;
  resetPattern: () => void;
};

export const gameState$ = observable<GameState>({
  pattern: Pattern.EASY,
  setPattern: (pattern: Pattern) => {
    batch(() => {
      towersState$.resetBricks();
      autoBetState$.resetAutoBetStats();
      autoBetState$.resetPickedBricks();
      gameState$.pattern.set(pattern);
      winDisplayState$.hideWinDisplay();
    });
  },
  resetPattern: () => {
    gameState$.pattern.set(Pattern.EASY);
  },
});
